import { ComposerPrimitive } from '@assistant-ui/react';

import { inputClassName } from '@playbooks/ui/components/input';
import { cn } from '@playbooks/ui/lib/utils';

import { ComposerAttachments } from 'components/composer/composer-attachments';
import { ComposerUrlReferences } from 'components/composer/composer-url-references';

const ComposerMessage = ({ disabled = false, placeholder }) => {
	// Theme
	const inputRootClassName = cn(
		inputClassName,
		'aspect-auto h-auto min-h-20 max-h-48 min-w-0 max-w-full resize-none overflow-y-auto rounded-none border-none bg-transparent py-3 shadow-none hover:border-transparent focus-visible:border-transparent focus-visible:ring-0',
	);

	// Render
	return (
		<div>
			<ComposerUrlReferences />
			<ComposerAttachments disabled={disabled} />
			<ComposerPrimitive.Input
				aria-label='Message agent'
				disabled={disabled}
				placeholder={placeholder}
				submitMode='enter'
				className={inputRootClassName}
			/>
		</div>
	);
};

export { ComposerMessage };
